/**
 * Tree keyboard shortcuts (see useTreeKeyboardNavigation).
 * Single source for labels shown in menus and tooltips.
 */
export const TREE_KEYBOARD_SHORTCUTS = {
  navigate: '↑ ↓ ← →',
  expandCollapse: 'Enter',
  edit: 'Ctrl+E',
  reload: 'F6',
  add: '+',
} as const;

/** Append shortcut in parentheses for tooltips, e.g. " (F6)". */
export function treeShortcutHint(shortcut: string): string {
  return ` (${shortcut})`;
}

/** Multi-line summary for menu footers (tree focus; not active in detail pane or inputs). */
export const TREE_KEYBOARD_HELP_LINES = [
  `${TREE_KEYBOARD_SHORTCUTS.navigate} — move`,
  `${TREE_KEYBOARD_SHORTCUTS.expandCollapse} — expand / collapse`,
  `${TREE_KEYBOARD_SHORTCUTS.edit} — edit`,
  `${TREE_KEYBOARD_SHORTCUTS.reload} — reload node`,
  `${TREE_KEYBOARD_SHORTCUTS.add} — add (same as + button)`,
] as const;

export const TREE_KEYBOARD_HELP_TEXT = TREE_KEYBOARD_HELP_LINES.join('\n');
